import React from 'react';

import Navigator from 'components/molecules/Navigator';

import styles from './index.css';

const Header = () => (
	<header className={styles.header}>
		<Navigator />
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/organisms/Header/index.js